module.exports = __webpack_public_path__ + "img/solution@2x.6c5f9c4f.png";